import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useGetSalesListQuery } from "../../../features/api/saleslistApi";

const StockBook = () => {
  const { state } = useLocation();
  console.log(state);

  const orders =
    useGetSalesListQuery(null, {
      refetchOnMountOrArgChange: true,
    })?.data?.orderss?.filter((order) => order?.model_id === state?.modelId) ||
    [];

  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }
  return (
    <div className="p-4">
      <Link
        to="/dashboard/report/stock"
        className="font-bold text-sm text-blue-500"
      >
        {" "}
        {"< Back"}
      </Link>
      <h1 className="font-medium text-center ">
        <span className="text-2xl font-medium text-center text-orange-500">
          Office Stock Book
        </span>{" "}
        ({" "}
        <span className="text-xl">
          {state?.productName} : {state?.modelName}
        </span>{" "}
        )
      </h1>

      <table className="table-auto w-full mt-4">
        <thead>
          <tr>
            <th className="border px-4 py-2">Serial No.</th>
            <th className="border px-4 py-2">Institution Name</th>
            <th className="border px-4 py-2">Quantity Sold</th>
            <th className="border px-4 py-2">Date</th>
          </tr>
        </thead>
        <tbody>
          {orders?.map((order, index) => (
            <tr key={index}>
              <td className="border px-4 py-2">{index + 1}</td>
              <td className="border px-4 py-2">{order?.dealerName}</td>
              <td className="border px-4 py-2">{order?.qty}</td>
              <td className="border px-4 py-2">{formatDate(order?.d_date)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StockBook;
